


























































































import { Component, Mixins, Prop, Vue, Watch } from 'vue-property-decorator'
import { mapState, mapActions, mapGetters} from 'vuex'
import Loading  from '@/components/Loading.vue'
import NoData from '@/components/NoData.vue'
import { formatDateTime } from '@/utils/date'
import TranslateMixin from '@/mixins/translate'
import { handleOpenApp, init } from '@/utils/lanuchApp';
import { loadScript } from '@/utils/util';

import { Route } from 'vue-router';
import { Store } from 'vuex';

interface SSRContext {
  meta?: {
    title: string;
    description: string;
    imageUrl: string;
  };
}

interface AsyncDataParams {
  store: Store<any>;
  route: Route;
  ssrContext: SSRContext | null;
  app: Vue;
}



var setStyle = function(cssArr: Array<string>){
  var i= 0,len = cssArr.length;
  for(i;i<len;i++){
    import(`@/assets/style/${cssArr[i]}`)
  }
};

var is_mobi = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().match(/(ipod|ipad|iphone|android|coolpad|mmp|smartphone|midp|wap|xoom|symbian|j2me|blackberry|wince)/i) != null;
if (is_mobi) {
    // window.location.href = "手机端";
}else{
    // window.location.href = "PC端";
    setStyle(['hls/video-js.css']);
}

declare const YT:any;
declare const window: any;
var player: any = null;
declare const videojs: any;
@Component({
  computed: mapGetters([
    'feedDetail',
    'initData',
    'comment',
  ]),
  methods: mapActions([
    'getFeedDetail',
    'getComment',
    'reportSend',
  ]),
  components: {
    Loading,
    NoData
  }
})
export default class Detail extends Mixins(TranslateMixin) {

  private query!: any;

  feedDetail!: any;
  comment!: any

  getFeedDetail!: (params: object) => Promise<void>;

  getComment!: (params: object) => Promise<void>;
  reportSend!: (params: object) => Promise<void>;

  private commentData = {} as any;
  private ownerInfo = {};
  private publishTime = '';
  private clubInfo = {};
  private commentNum = 0;
  private greatNum = 0;
  private source = ''; // 视频来源 FOR_FACEBOOK,  FOR_YOUTUBE, FOR_PUBGM, FOR_INSTAGRAM, FOR_UNSPECIFIED, FOR_TWITTER, FOR_AUTO
  private thirdPlayUrl = '';

  private videoFormatMap = {
    "MPEG": "video/mpeg",
    "MPG": "video/mpeg",
    "MP4": "video/mp4",
    "M4V": "video/mp4",
    "3GP": "video/3gpp",
    "3GPP": "video/3gpp",
    "3G2": "video/3gpp2",
    "3GPP2": "video/3gpp2",
    "MKV": "video/x-matroska",
    "WEBM": "video/webm",
    "TS": "video/mp2ts",
    "AVI": "video/avi",
    "WMV": "video/x-ms-wmv",
    "ASF": "video/x-ms-asf",
  } as any;
  private videoType = 'video/mp4'; // 播放格式
  private display = true; // 是否显示
  private isPc = !is_mobi; // 是否是PC
  private isHls = false; // 是否是m3u8的hls

  // meta
  private title = '';
  private description = '';
  private imageUrl = '';

  // 包跳转协议 
  private schema = 'igame1320'

  // metaInfo() {
  //   return {
  //     title: this.title,
  //     meta: [
  //       // Open Graph 标签 (Facebook/Discord)
  //       { property: 'og:title', content: this.title },
  //       { property: 'og:description', content: this.description },
  //       { property: 'og:image', content: this.imageUrl },

  //       // Twitter Card 标签
  //       { name: 'twitter:card', content: 'summary_large_image' },
  //       { name: 'twitter:title', content: this.title },
  //       { name: 'twitter:description', content: this.description },
  //       { name: 'twitter:image', content: this.imageUrl },
  //     ],
  //   };
  // }

  async asyncData({ store, route, ssrContext }: AsyncDataParams) {
    try {
      // console.error("****** asyncData call begin", route, ssrContext);
      const { openid, id } = route.query;
      const feedDetail = await store.dispatch('getFeedDetail', { open_id: openid, iid: id });
      // console.error("****** asyncData feedDetail", store.state, feedDetail);
      // 在这里设置元数据
      const { body } = feedDetail || store.state.feedDetail;
      const {
        data,
      } = body;
      let title = '';
      let description = '';
      let imageUrl  = '';
      if (data) {
        const { content, video, image_urls, } = JSON.parse(data);
        title = content;
        description = content;
        imageUrl = (image_urls && image_urls[0]) || (video && video.img_url);
      }
      // // 将元数据添加到 ssrContext 中
      // if (app.context.ssrContext) {
      //   app.$eventBus.$emit('update-meta', { title, description, imageUrl });
      // }

      // 将元数据设置为根实例的 meta 属性
      // app.$root.meta = { title, description, imageUrl };
      if (ssrContext) {
        ssrContext.meta = { title, description, imageUrl };
        // console.error('asyncData:', title, description, imageUrl);
      }
      return { title, description, imageUrl };
    } catch (error) {
      console.error('Error during asyncData:', error);
      return { title: '', description: '', imageUrl: '' };
    }
  }

  // async mounted() {
  //   // if (process.env.WEBPACK_TARGET == 'node') return;
  //   // await this.fetch();
  //   this.$setMeta({ title: this.title, description: this.description, imageUrl: this.imageUrl });
  // }

  async created() {
    try {
      await init();
      this.query = this.$route.query
      console.log('** test params:', this.query);
      // schema=igame1320
      const { openid, id, schema } = this.query;
      if (schema) {
        this.schema = schema;
      }
      await this.getFeedDetail({'open_id': openid, iid: id});
      if (this.feedDetail.error) {
        this.display = false;
      }

      const param = {
        common: {
          openid
        },
        param: {
          iid: id,
          openid,
          action: "feed",
          subaction: "h5_detail"
        }
      };

      this.reportSend(param)

      // const { body } = this.feedDetail;
      // const {
      //   data,
      // } = body;
      // if (data) {
      //   const { content, video, image_urls, } = JSON.parse(data);
      //   this.addMetaTags(content, content, (image_urls && image_urls[0]) || (video && video.img_url));
      //   // this.$meta().meta = { title: this.title, description: this.description, imageUrl: this.imageUrl }
      // }
      // // this.body = (this as any).feedDetail.body || {};
      // console.log("====>getComment:", this.display, this.feedDetail)
      // 获取评论
      await this.getComment({
        "game_id": 0,
        "rend": 3,
        "rstart": 0, // 翻页开始位置
        "sorting": 1, // 排序方式，0正向，1反向
        "topic_id": id,
        "scenes": 1,
      });
      // console.log("=====>getComment end:", this.comment);
    } catch (error) {
      console.error('Error caught:', error);
    }
  }

  // 这种compute失效， 看是否是因为头部设置了Computed的原因
  get canGreat () {
    // console.log('cccccc')
    // return this.body
    return ''
  }

  @Watch("feedDetail")
  private async watchBody(val: any) {
    const { body } = val;
    if (!body) {
      return false;
    }
    const {
      data,
      ownerInfo,
      time,
      club,
      commNum,
      greatNum,
      source,
    } = body;
    if (data) {
      const { content, video, image_urls, } = JSON.parse(data);
      this.commentData = {
        content,
        videoUrl: video.video_url,
        imageUrl: image_urls && image_urls[0],
        vid: video.vid,
      };
      this.addMetaTags(content, content, (image_urls && image_urls[0]) || (video && video.img_url));
      this.$setMeta({ title: this.title, description: this.description, imageUrl: this.imageUrl });
    }
    console.log("=====> watch body")
    this.source = source;
    if (this.commentData.videoUrl && this.commentData.videoUrl.toLowerCase().indexOf('.m3u8') !== -1) {
      this.isHls = true;
    } else {
      this.isHls = false;
    }
    this.videoType = this.getVideoType(this.commentData.videoUrl);
    if (this.source === 'FOR_FACEBOOK') {
      if (!this.videoType) {
        // facebook 如果不是播放源，则用facebook的播放器， 否则用video标签
        this.thirdPlayUrl = `https://www.facebook.com/plugins/video.php?href=${encodeURIComponent(this.commentData.videoUrl)}&autoplay=true&allowfullscreen=true`;
      }
    } else if (this.source === 'FOR_YOUTUBE') {
      if (typeof document !== 'undefined') {
        // 初始化播放器脚本
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0] as any;
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
      }
      // var player
      // 3. This function creates an <iframe> (and YouTube player)
      //    after the API code downloads.
      if (typeof window != 'undefined') {
        window.onYouTubeIframeAPIReady = function() {
          player = new YT.Player('player', {
            events: {
              'onReady': window.onPlayerReady,
            }
          });
        }

        // 4. The API will call this function when the video player is ready.
        window.onPlayerReady = function(event: any) {
          event.target.playVideo();
          event.target.mute();
        }
      }

    }
    console.log("=====> render video body")
    this.ownerInfo = ownerInfo;
    const publishTime = new Date(time*1);
    const diff = (Date.now() - publishTime.getTime())/(1000*60) // 分钟
    if (diff < 1) {
      this.publishTime = this.$t('feed_time_now'); // '刚刚';
    } else if (diff < 60) {
      this.publishTime = this.$t('feed_time_min', `${Math.round(diff)}`); // `${Math.round(diff)}分钟前`;
    } else if (diff < 24*60) {
      this.publishTime = this.$t('feed_time_hour', `${Math.round(diff/60)}`); // `${Math.round(diff/60)}小时前`;
    } else {
      const tmpTimeStr = formatDateTime(publishTime);
      this.publishTime = tmpTimeStr.split(' ')[0];
    }
    this.clubInfo = club;
    this.commentNum = commNum;
    this.greatNum = greatNum;
    if (this.isPc) {
      this.$nextTick(async () => {
        await loadScript('https://cdn.club.gpubgm.com/meemo/dist/js/video.js')
        await loadScript('https://cdn.club.gpubgm.com/meemo/dist/js/videojs-hls.js')
        const player = videojs('hls-container');
        player.play();
        const hlsNode = (this.$refs.hlsContainer as any).parentNode as any
        hlsNode.style.width = '100%'
        hlsNode.style.height = '100%'
        if (typeof document !== 'undefined') {
          const playButton = document.querySelector('.vjs-big-play-button') as any
          playButton.style.top = '50%'
          playButton.style.left = '50%'
        }
      })
    }
    console.log("=====> end watch body")
  }

  private getVideoType (url: string) {
    if (!url) {
      return '';
    }
    const lastDotIndex = url.lastIndexOf('.') as number;
    if (lastDotIndex < 0 ) {
      return '';
    }
    return this.videoFormatMap[(url.substring(lastDotIndex + 1).toUpperCase())];
  }

  private jumpClub (e: Event) {
    console.log('**** jumpTest:', e)
    const { page, id, extra } = this.query;
    let jumpUrl = `${page}?id=${id}&extra=${extra}`
    if (id == "47f74660c6ef45e3ad0bbcc5f63a1b15") {
      jumpUrl = 'home_page?game_scene=h5_influencer'
    }
    var app = {
        scheme: `${this.schema}://`,
        schemeLaunchParam: `module=100030?deeplink=${encodeURIComponent(`igamesdk://meemo/${jumpUrl}`)}`,
        downloadUrl: 'market://details?id=com.tencent.ig',
        path: 'module=100030',
        params: {
          deeplink: `${encodeURIComponent(`igamesdk://meemo/${jumpUrl}`)}`,
        },
        schemeOnly: this.schema,
    }
    // 判断一下如果是ipad，直接用scheme+schemeLaunchParam来拉起app
    const isIPad = typeof document !== 'undefined' && /iPad|Macintosh/i.test(navigator.userAgent) &&
                  'ontouchend' in document;

    if (typeof document !== 'undefined' && isIPad) {
      // For iPad, directly use scheme URL
      const schemeUrl = `${app.scheme}${app.schemeLaunchParam}`;
      window.location.href = schemeUrl;

      // // Fallback to app store after delay
      // setTimeout(() => {
      //   if (!document.hidden) {
      //     window.location.href = app.downloadUrl;
      //   }
      // }, 500);
    } else {
      handleOpenApp(app);
    }
  }

  private jumpClubDetail (e: Event) {
    const { page, id, extra } = this.query;
    var app = {
        scheme: `${this.schema}://`,
        schemeLaunchParam: `module=100030?deeplink=${encodeURIComponent(`igamesdk://meemo/club_homepage?id=${(this.clubInfo as any).clubId}&extra=${extra}`)}`,
        downloadUrl: 'market://details?id=com.tencent.ig',
        path: 'module=100030',
        params: {
          deeplink: `${encodeURIComponent(`igamesdk://meemo/club_homepage?id=${(this.clubInfo as any).clubId}&extra=${extra}`)}`,
        },
        schemeOnly: this.schema,
    }
    handleOpenApp(app);
  }

  private addMetaTags(title: string, description: string, imageUrl: string) {
    this.title = title;
    this.description = description;
    this.imageUrl = imageUrl;
    // if (typeof document === 'undefined') {
    //   return null;
    // }
    // 创建 Open Graph 标签 (Facebook/Discord)
    // for test
    // imageUrl = 'https://image-1300342626.cos.ap-singapore.myqcloud.com/meemo-test/dist/img/defaultAvatar.5b7fe123.jpg';
    // const ogTitle = document.createElement("meta");
    // ogTitle.setAttribute("property", "og:title");
    // ogTitle.content = title;

    // const ogDescription = document.createElement("meta");
    // ogDescription.setAttribute("property", "og:description");
    // ogDescription.content = description;

    // const ogImage = document.createElement("meta");
    // ogImage.setAttribute("property", "og:image");
    // ogImage.content = imageUrl;

    // // 创建 Twitter Card 标签
    // const twitterCard = document.createElement("meta");
    // twitterCard.name = "twitter:card";
    // twitterCard.content = "summary_large_image";

    // const twitterTitle = document.createElement("meta");
    // twitterTitle.name = "twitter:title";
    // twitterTitle.content = title;

    // const twitterDescription = document.createElement("meta");
    // twitterDescription.name = "twitter:description";
    // twitterDescription.content = description;

    // const twitterImage = document.createElement("meta");
    // twitterImage.name = "twitter:image";
    // twitterImage.content = imageUrl;

    // // 将标签插入到 head 中
    // const head = document.getElementsByTagName("head")[0];
    // head.appendChild(ogTitle);
    // head.appendChild(ogDescription);
    // head.appendChild(ogImage);
    // head.appendChild(twitterCard);
    // head.appendChild(twitterTitle);
    // head.appendChild(twitterDescription);
    // head.appendChild(twitterImage);
  }

}

// (Detail as any).options.asyncData = Detail.prototype.asyncData;
